import { SmtpConnectionStatus } from "~/gql/graphqlBase.generated";

export type OwnEmailSystemStatusState = "failed" | "notConfigured" | "unverified" | "verified";

export interface OwnEmailSystemStatusChip {
	color: "default" | "error" | "success" | "warning";
	label: string;
}

const STATUS_CHIPS: Record<OwnEmailSystemStatusState, OwnEmailSystemStatusChip> = {
	failed: { color: "error", label: "Verification failed" },
	notConfigured: { color: "default", label: "Not configured" },
	unverified: { color: "warning", label: "Not verified" },
	verified: { color: "success", label: "Verified" }
};

export const ownEmailSystemStatusChip = (state: OwnEmailSystemStatusState): OwnEmailSystemStatusChip =>
	STATUS_CHIPS[state];

const CONNECTION_STATUS_STATES: Record<SmtpConnectionStatus, OwnEmailSystemStatusState> = {
	[SmtpConnectionStatus.Failed]: "failed",
	[SmtpConnectionStatus.Unverified]: "unverified",
	[SmtpConnectionStatus.Verified]: "verified"
};

export const ownEmailSystemStatusState = (status?: SmtpConnectionStatus | null): OwnEmailSystemStatusState =>
	status ? CONNECTION_STATUS_STATES[status] : "notConfigured";

export type SmtpTestSendOutcome = "failed" | "unknown" | "verified";

export const smtpTestSendOutcome = (status?: SmtpConnectionStatus | null): SmtpTestSendOutcome => {
	if (status === SmtpConnectionStatus.Verified) return "verified";
	if (status === SmtpConnectionStatus.Failed) return "failed";
	return "unknown";
};
